import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UploadAttachment } from 'src/app/shared/components/upload-attachments/upload-attachment.model';

@Component({
    selector: 'comment-with-attachments-dialog',
    styleUrls: ['./comment-with-attachments-dialog.component.scss'],
    templateUrl: './comment-with-attachments-dialog.component.html'
})
export class CommentWithAttachmentsDialogComponent {
    comment = '';
    attachments: UploadAttachment[] = [];
    data: any = {};

    constructor(
        private readonly dialogRef: MatDialogRef<CommentWithAttachmentsDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        data: {
            title: string;
            infoText: string;
            dataQaId: string;
        }
    ) {
        this.data = data;
    }

    close(comment?: string): void {
        if (comment) {
            this.dialogRef.close({
                comments: comment,
                attachments: this.attachments
            });
        } else {
            this.dialogRef.close(false);
        }
    }

    onSelectedFiles(files: UploadAttachment[]): void {
        files.forEach((x) => {
            x.pending = false;
            this.attachments.push(x);
        });
    }

    onRemovedFile(file: UploadAttachment): void {
        this.attachments.splice(
            this.attachments.findIndex((x) => x.title === file.title),
            1
        );
    }
}
